// src/app/httpClient.ts
import { fetchUtils } from "react-admin";
import type { RequestOptions } from "./types/api";
import { API_ORIGIN } from "./config";

export const httpClient: typeof fetchUtils.fetchJson = (
  url: string,
  options: RequestOptions = {},
) => {
  const token = localStorage.getItem("tn_admin_access");
  options.headers = new Headers(
    options.headers || { Accept: "application/json" },
  );
  if (token) {
    (options.headers as Headers).set("Authorization", `Bearer ${token}`);
  }
  // Remove credentials to avoid CORS issues with wildcard origin
  // options.credentials = "include";
  return fetchUtils.fetchJson(url, options);
};

// Helper so you can build absolute URLs consistently
export const apiUrl = (path: string): string => {
  // If API_ORIGIN is set, use it (for production)
  if (API_ORIGIN) {
    return `${API_ORIGIN}${path}`;
  }
  // For development, use the proxy path directly
  return path;
};
